import React, { useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import {
  DialogActions,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { Box } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { AlertPopUp } from "../components/AlertPopUp";
import {
  getCustomerByPhoneNo,
  registerClient,
  updateClient,
} from "../apis/RangerOnlineApi";
import { DigitalClock } from "../components/DigitalClock";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { getDefaultDateTime, validateEmail } from "../Utils/utils";

const getDefaultDate = (date) => {
  const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  return newDate;
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(0),
    display: "flex",
    justifyContent: "space-between",
    marginTop: "15px",
  },
  "&:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 1000px white inset",
    fontSize: "30px",
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "&:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 1000px white inset",
    fontSize: "30px",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      sx={{ m: 0, p: 2 }}
      {...other}
      style={{ display: "flex", justifyContent: "center" }}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
};

const getDefaultInfo = (minutes = 0) => {
  return {
    id: 0,
    clientId: 0,
    orderType: "PICKUP",
    firstName: "",
    lastName: "",
    phoneNo: "",
    email: "",
    orderDesc: "PICKUP   Customer Name:",
    date: getDefaultDateTime(minutes),
    time: getDefaultDateTime(minutes),
  };
};

const getHour = (date) => {
  let currentHour = date.getHours();
  let currentMinutes = date.getMinutes();
  let currentPeriod = currentHour >= 12 ? "pm" : "am";
  currentHour = currentHour % 12;
  currentHour = currentHour ? currentHour : 12;

  return `${currentHour.toString().padStart(2, "0")}:${currentMinutes
    .toString()
    .padStart(2, "0")} ${currentPeriod}`;
};

export const PickUpOrderDialog = (props) => {
  const { open, onClose, onOrderSelection, pickUpTime, companyName } = props;
  let navigate = useNavigate();
  const [pickUpInfo, setPickUpInfo] = useState(getDefaultInfo(pickUpTime + 5));
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showClock, setShowClock] = useState(false);
  //const [date, setDate] = useState(new Date());

  /*const refreshClock = () => {
    setDate(new Date());
  };*/

  const handleAlert = (show, message) => {
    setShowAlert(show);
    setAlertMessage(message);
  };

  const handleDateChange = (newValue) => {
    const data = { ...pickUpInfo };

    data.date = newValue;

    setPickUpInfo(data);
  };

  const handleTimeChange = (newValue) => {
    const data = { ...pickUpInfo };

    data.time = newValue;
    setPickUpInfo(data);
    setShowClock(false);
  };

  const handleTextChange = (e) => {
    const id = e.target.id;
    const value = e.target.value;
    let letters = /^[a-zA-Z ]*$/;
    if (value.match(letters)) {
      let data = { ...pickUpInfo };
      data[id] = value;
      setPickUpInfo(data);
    }
  };

  const handleEmailChange = (e) => {
    const id = e.target.id;
    const value = e.target.value;
    let data = { ...pickUpInfo };
    data[id] = value;
    setPickUpInfo(data);
  };

  const handlePhoneChange = (e) => {
    const re = /^[0-9\b]+$/;
    const value = e.target.value;
    let data = { ...pickUpInfo };
    if (value === "" || (re.test(value) && value.length <= 10)) {
      data.phoneNo = value;
      setPickUpInfo(data);
    }
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      let client = {};
      let clientId = 0;
      if (pickUpInfo.phoneNo.length < 10) {
        handleAlert(true, "Error the phone number is invalid.");
        return;
      }

      if (pickUpInfo.firstName === "") {
        handleAlert(true, "Please enter your first name.");
        return;
      }

      if (pickUpInfo.email != "" && !validateEmail(pickUpInfo.email)) {
        handleAlert(true, "Please enter a valid mail.");
        return;
      }

      if (
        getDefaultDate(pickUpInfo.date) < getDefaultDate(getDefaultDateTime(0))
      ) {
        handleAlert(true, "Please select a valid date.");
        return;
      }
      if (pickUpInfo.time < getDefaultDateTime(pickUpTime)) {
        handleAlert(true, "Please select a valid hour.");
        return;
      }

      pickUpInfo.phoneNo = pickUpInfo.phoneNo;
      pickUpInfo.orderDesc = pickUpInfo.orderDesc + pickUpInfo.firstName;

      await getCustomerByPhoneNo(pickUpInfo.phoneNo).then((x) => {
        if (x?.status && x?.status === 500) {
          handleAlert(
            true,
            "There was a communication please contact the support team."
          );
        }
        client = x;
      });

      if (client?.clientId > 0) {
        clientId = client.clientId;
        pickUpInfo.clientId = clientId;
        await updateClient("pickup", pickUpInfo);
      } else {
        client = await registerClient(pickUpInfo);
        clientId = client.clientId;
        pickUpInfo.clientId = clientId;
      }

      onOrderSelection(pickUpInfo);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        //onClose={onClose}
        maxWidth="xs"
        fullWidth={true}
      >
        <BootstrapDialogTitle id="customized-dialog-title">
          Pick Up:
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <form onSubmit={(e) => handleSubmit(e)}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "15px",
                flexDirection: "column",
              }}
            >
              <StyledTextField
                id="phoneNo"
                type="tel"
                required
                label="Phone No."
                variant="outlined"
                onChange={(e) => handlePhoneChange(e)}
                value={pickUpInfo.phoneNo}
                fullWidth
              />
              <TextField
                id="email"
                type="text"
                label="E-Mail:"
                variant="outlined"
                value={pickUpInfo.email}
                onChange={handleEmailChange}
                fullWidth
              />
              <TextField
                id="firstName"
                required
                label="First Name:"
                variant="outlined"
                value={pickUpInfo.firstName}
                onChange={handleTextChange}
                fullWidth
              />
              <TextField
                id="lastName"
                label="Last Name:"
                variant="outlined"
                value={pickUpInfo.lastName}
                onChange={handleTextChange}
                fullWidth
              />
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  id="date"
                  label="Date:"
                  inputFormat="MM/dd/yyyy"
                  value={pickUpInfo.date}
                  onChange={(e) => handleDateChange(e)}
                  renderInput={(params) => (
                    <TextField required {...params} fullWidth />
                  )}
                  minDate={getDefaultDateTime(pickUpTime)}
                  maxDate={getDefaultDateTime(pickUpTime)}
                />
              </LocalizationProvider>

              <FormControl variant="outlined" required fullWidth focused>
                <InputLabel htmlFor="time">Time:</InputLabel>
                <OutlinedInput
                  id="time"
                  type="text"
                  value={getHour(pickUpInfo.time)}
                  onClick={() => {
                    setShowClock(true);
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle digital clock"
                        edge="end"
                        onClick={() => setShowClock(true)}
                      >
                        <AccessTimeIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Time:"
                />
              </FormControl>
              <Typography variant="body2">
                {`By proceeding, you consent to get calls, SMS messages, or emails
                including by automated means, from ${companyName} and its affiliates to
                the number and email provided.`}
              </Typography>
            </Box>
            <DialogActions sx={{ padding: "" }}>
              <Button
                variant="outlined"
                color={"error"}
                onClick={onClose}
                fullWidth
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                color={"primary"}
                type="submit"
                fullWidth
              >
                Submit
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
        {showAlert ? (
          <AlertPopUp
            show={showAlert}
            message={alertMessage}
            onClose={() => handleAlert(false, "")}
            closeOnTimer={false}
          />
        ) : null}
        {showClock ? (
          <DigitalClock
            date={pickUpInfo.time}
            open={showClock}
            onAlert={handleAlert}
            onClose={() => setShowClock(false)}
            onSave={handleTimeChange}
          />
        ) : null}
      </BootstrapDialog>
    </>
  );
};
